import {
    get,
    post
} from '../Requisitions';
var config = require('../../config.json');

export var rescues = {
    redeemRewards: function (tokenCliente, data,admin) {
        data.acao = 'inserir';
        data.estabelecimento = admin;

        return post('resgate', {
            'Token': config.token,
            'Token-Cliente': tokenCliente
        }, data);
    },
    getRedeemption: function (idResgate, tokenCliente, admin) {
        return get('resgate/' + admin +
            '/' + idResgate, {
                'Token': config.token,
               
                'Token-Cliente': tokenCliente
            });
    },
    getRedeemptionsByCustomer: function (tokenCliente,admin) {
        return get('resgate/' + admin, {
            'Token': config.token,
            'Cache-Control': 'no-cache',
            'Token-Cliente': tokenCliente
        });
    }
}